import { GOOGLE_FONT_FAMILIES } from './googleFonts';
import type { GlassSelectOption } from '../components/ui/GlassSelect';

// The bundled Google Fonts catalogue as GlassSelect options. Built once at
// module load and shared by every font picker (brand portal, preview modal).
// Kept separate from the auto-generated googleFonts.ts so regeneration can't
// clobber it.
export const GOOGLE_FONT_OPTIONS: GlassSelectOption[] =
  GOOGLE_FONT_FAMILIES.map((f) => ({ value: f, label: f }));
